import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RegisterHeader } from './RegistrationStepCompanyData';
import { selectResponsibleManager } from '../../../entities/registration/model';
import { selectCurrentInvite } from '../../../entities/invite/model';
import { Link } from 'react-router-dom';
import { Button } from '../../../shared/ui/button';

export const RegistrationStepConfirmation = () => {
  const responsibleManager = useSelector(selectResponsibleManager);
  const invite = useSelector(selectCurrentInvite);
  const navigate = useNavigate();

  if (invite?.type === 'employee') {
    return (
      <div className="relative">
        <RegisterHeader
          title="Регистрация завершена"
          description="Вы успешно зарегистрировались. Теперь вы можете войти в свою учетную запись, используя указанные при регистрации данные."
        />
        <Link style={{ color: 'blue' }} to="/login" className="login-button">
          Перейти на страницу входа
        </Link>
      </div>
    );
  }

  return (
    <div className="relative">
      <RegisterHeader
        title="Спасибо за заполнение всех полей формы"
        description={`Данную форму проверит Ваш персональный менеджер ${responsibleManager?.name}.
  Обычно это занимает не больше одного рабочего дня. По завершении модерации Вы получите сообщение об активации Вашей учетной записи на указанный электронный адрес.`}
      />
      {/*
        Финальный шаг для регистрации компании раньше был «тупиком»:
        форма закрывалась RegisterHeader'ом, но кнопки/ссылки на
        логин не было — юзер залипал, пока не вспомнит, что в
        адресной строке есть `/login`. Добавляем явный CTA, в той же
        стилистике, что и Button по всему флоу регистрации.
      */}
      <div className="mt-6">
        <Button onClick={() => navigate('/login')}>
          Перейти на страницу входа
        </Button>
      </div>
    </div>
  );
};
